module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAgklEQVRoBe3YwQ2AIAyF4dYJXMlJHQlHcYMaEg6eDCaatvB/F06Q9yAkBAEAAJ3MbDWzvY4p96yFr0rKEu0ECiW8USKK6UuEQYkoKBHFVCX0YQH7NeF7h4hsqnreZy7BQo4j9T0gvBfCeyG8l+nDuyG8l/TP5FG+FvN+7gIA8CkRuQDcxN6xdOfaDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_btn_arrow@2x.png
// module id = 715
// module chunks = 0